import { AbstractControl, Validators } from '@angular/forms';

// tslint:disable-next-line:function-name
export function RequiredAfterTrimmingValidator(control: AbstractControl): { [key: string]: boolean } | null {
  if (Validators.required(control) || !(control.value || '').trim().length) {
    return { required: true };
  }
  return null;
}
